import React, { Component } from "react";
import { Redirect } from "react-router";
import {
  MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBIcon
} from "mdbreact";
import API_URL from '../config';
import axios from 'axios';
import fondo4 from "./Fondo4.jpg";
import { puede } from "../permisos";

class AdminDashboard extends Component {
  state = { redirigir: "" };

  getToken = function() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    return datos && datos[0] ? datos[0].autorizacion : "";
  }

  componentDidMount() {
    this.ultimaVerificacion = Date.now();
    this.eventosInteraccion = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    this.handlerInteraccion = this.verificarEnInteraccion.bind(this);
    this.eventosInteraccion.forEach(function(ev) { window.addEventListener(ev, this.handlerInteraccion); }.bind(this));
  }

  componentWillUnmount() {
    if (this.eventosInteraccion && this.handlerInteraccion) {
      this.eventosInteraccion.forEach(function(ev) { window.removeEventListener(ev, this.handlerInteraccion); }.bind(this));
    }
  }

  verificarEnInteraccion = function() {
    var ahora = Date.now();
    if (ahora - this.ultimaVerificacion < 15000) return;
    this.ultimaVerificacion = ahora;
    this.verificarUsuarioActivo();
  }

  verificarUsuarioActivo = function() {
    var token = this.getToken();
    if (!token) return;
    axios.post(API_URL + '/verificarusuarioactivo/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ autorizacion: token })
    })
    .then(function(response) {
      if (response.data && response.data.length > 0 && response.data[0].activo === 0) {
        sessionStorage.clear();
        window.location.replace('/');
      }
    })
    .catch(function() { /* Error de red: no cerrar sesión */ });
  }

  render() {
    var datos = this.props.location.state ? this.props.location.state.datos : null;
    if (datos) { sessionStorage.setItem('datos', JSON.stringify(datos)); }
    else { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    if (!datos) return <Redirect to="/" />;

    if (this.state.redirigir) {
      return <Redirect push={false} to={{ pathname: this.state.redirigir, state: { datos: datos } }} />;
    }

    // 11/08/2026 - Las tarjetas ya no son una lista fija: cada una declara el
    // modulo que necesita y solo se muestra si el rol del usuario lo concede.
    // Los permisos se administran en /admin/permisos de RemuneracionesWeb.
    var opciones = [
      {
        modulo: "BOLETAS_ADMIN",
        icon: "file-invoice-dollar",
        titulo: "Consulta de Boletas",
        descripcion: "Busque por DNI y descargue boletas de pago de cualquier trabajador sin restricción.",
        color: "#7A1622",
        ruta: "/admin-boletas"
      },
      {
        modulo: "BOLETAS_COMPROBANTE",
        icon: "receipt",
        titulo: "Boletas con Comprobante",
        descripcion: "Registre el comprobante de pago y descargue boletas contra su saldo, con tope de descargas.",
        color: "#00838F",
        ruta: "/admin-boletas-comprobante"
      },
      {
        modulo: "CONTROL_DESCARGAS",
        icon: "chart-bar",
        titulo: "Control de Descargas",
        descripcion: "Reportes de descargas realizadas por operadores: por día, semana, mes, año, montos y cantidades.",
        color: "#1565C0",
        ruta: "/admin-control-descargas"
      },
      {
        modulo: "GESTION_COMPROBANTES",
        icon: "tools",
        titulo: "Gestión de Comprobantes",
        descripcion: "Corrija comprobantes con datos erróneos, modifique montos y habilite descargas extras para operadores.",
        color: "#F57C00",
        ruta: "/admin-gestion-comprobantes"
      },
      {
        modulo: "GESTION_USUARIOS",
        icon: "users-cog",
        titulo: "Gestión de Usuarios",
        descripcion: "Consulte las cuentas del sistema, habilítelas o reinicie contraseñas. Los roles se asignan en Remuneraciones Web.",
        color: "#2E7D32",
        ruta: "/admin-gestion-usuarios"
      },
      {
        modulo: "DJ_GESTION",
        icon: "calendar-alt",
        titulo: "Declaraciones Juradas",
        descripcion: "Aperture y gestione los calendarios de declaraciones juradas para los trabajadores.",
        color: "#6A1B9A",
        ruta: "/admin-declaraciones-juradas"
      },
      {
        modulo: "DJ_VALIDACION",
        icon: "clipboard-check",
        titulo: "Validar Declaraciones",
        descripcion: "Revise y valide las declaraciones juradas presentadas por los trabajadores.",
        color: "#455A64",
        ruta: "/admin-validar-declaraciones"
      }
    ].filter(function (op) { return puede(datos, op.modulo); });

    if (opciones.length === 0) {
      return (
        <MDBContainer className="mt-5 pt-5 text-center">
          <MDBIcon icon="lock" size="3x" style={{ color: "#9E9E9E" }} />
          <h5 className="mt-4">Su usuario no tiene módulos asignados</h5>
          <p className="text-muted">
            Solicite a la Sub Unidad de Remuneraciones que le asigne un rol con acceso a boletas.
          </p>
        </MDBContainer>
      );
    }

    return (
      <div style={{ position: "relative", minHeight: "calc(100vh - 4rem)" }}>
        <div style={{
          position: "fixed", top: "4rem", left: 0, width: "100%", height: "calc(100vh - 4rem)",
          backgroundImage: "url(" + fondo4 + ")", backgroundSize: "cover", backgroundPosition: "center", opacity: 0.1
        }} />

        <MDBContainer className="mt-5 pt-4" style={{ position: "relative", zIndex: 1 }}>
          <div className="text-center mb-5">
            <h4 className="font-weight-bold" style={{ color: "#7A1622" }}>
              <MDBIcon icon="user-shield" className="mr-2" />
              Panel de Administración
            </h4>
            <p className="text-muted" style={{ fontSize: "0.95rem" }}>
              Seleccione una opción para continuar
            </p>
          </div>

          <MDBRow center>
            {opciones.map(function(op, i) {
              return (
                <MDBCol md="3" className="mb-4" key={i}>
                  <MDBCard
                    className="h-100"
                    style={{
                      border: "2px solid " + op.color + "33", borderRadius: "16px",
                      boxShadow: "0 4px 20px rgba(0,0,0,0.08)", cursor: "pointer",
                      transition: "transform 0.2s, box-shadow 0.2s, border-color 0.2s", overflow: "hidden"
                    }}
                    onMouseEnter={function(e) { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 8px 30px " + op.color + "30"; e.currentTarget.style.borderColor = op.color; }}
                    onMouseLeave={function(e) { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 4px 20px rgba(0,0,0,0.08)"; e.currentTarget.style.borderColor = op.color + "33"; }}
                    onClick={function() { this.setState({ redirigir: op.ruta }); }.bind(this)}
                  >
                    <div style={{
                      background: "linear-gradient(135deg, " + op.color + ", " + op.color + "cc)",
                      height: "120px", display: "flex", alignItems: "center", justifyContent: "center"
                    }}>
                      <MDBIcon icon={op.icon} size="3x" style={{ color: "#fff" }} />
                    </div>
                    <MDBCardBody className="text-center px-3" style={{ paddingTop: "20px", paddingBottom: "20px" }}>
                      <h5 className="font-weight-bold mb-2" style={{ color: op.color, fontSize: "1.05rem" }}>
                        {op.titulo}
                      </h5>
                      <p className="text-muted mb-3" style={{ fontSize: "0.83rem" }}>
                        {op.descripcion}
                      </p>
                      <span style={{ color: op.color, fontWeight: "600", fontSize: "0.9rem" }}>
                        Ingresar <MDBIcon icon="arrow-right" className="ml-1" />
                      </span>
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
              );
            }.bind(this))}
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

export default AdminDashboard;
